// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__dTZcL","largestCol":"styles_largestCol__1IITI","smallestCol":"styles_smallestCol__2J9f-"};